// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

const scheduledEventKeys = {
  all: ['scheduled-event'] as const,
  scheduledEvent: (scheduledEventId: number | string) =>
    [...scheduledEventKeys.all, scheduledEventId] as const,
};

export default scheduledEventKeys;
